module.exports = __webpack_public_path__ + "static/media/fondoGarantiaImg.8ad48728.png";